import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOfferOnDiscount } from "src/models/Offers/OfferOnDiscount.models";

interface OfferOnDiscountState {
  offerOnDiscounts: IOfferOnDiscount[];
  offerOnDiscountToEdit: IOfferOnDiscount | null;
}

const initialState: OfferOnDiscountState = {
  offerOnDiscounts: [],
  offerOnDiscountToEdit: null,
};

const OfferOnDiscountSlice = createSlice({
  name: "OfferOnDiscount",
  initialState,
  reducers: {
    setOfferOnDiscountList: (
      state,
      action: PayloadAction<IOfferOnDiscount[]>
    ) => {
      state.offerOnDiscounts = action.payload;
    },
    concatListOfferOnDiscount: (
      state: OfferOnDiscountState,
      action: PayloadAction<IOfferOnDiscount[]>
    ) => {
      state.offerOnDiscounts = [
        ...state.offerOnDiscounts.concat(action.payload),
      ];
    },
    setOfferOnDiscountToEdit: (
      state,
      action: PayloadAction<IOfferOnDiscount | null>
    ) => {
      state.offerOnDiscountToEdit = action.payload;
    },
    addOfferOnDiscount: (state, action: PayloadAction<IOfferOnDiscount>) => {
      state.offerOnDiscounts.push(action.payload);
    },
    updateOfferOnDiscount: (state, action: PayloadAction<IOfferOnDiscount>) => {
      let itemIndex = state.offerOnDiscounts.findIndex(
        item => item.offerOnDiscountId === action.payload.offerOnDiscountId
      );
      if (itemIndex !== -1) state.offerOnDiscounts[itemIndex] = action.payload;
    },
    deleteOfferOnDiscount: (state, action: PayloadAction<number>) => {
      const newArray = state.offerOnDiscounts.filter(
        item => item.offerOnDiscountId !== action.payload
      );
      state.offerOnDiscounts = newArray;
    },
  },
});

export const {
  setOfferOnDiscountList,
  concatListOfferOnDiscount,
  setOfferOnDiscountToEdit,
  addOfferOnDiscount,
  updateOfferOnDiscount,
  deleteOfferOnDiscount,
} = OfferOnDiscountSlice.actions;

export default OfferOnDiscountSlice.reducer;
